import React, { useEffect, useState } from 'react'
import { AccentColorTypes, AccentTypes, SettingsPropsTypes, ThemeModesTypes } from './SettingsTypes'
import { DarkModeIcon, LightModeIcon, RainbowIcon } from '../iconSet/IconSet'
import { useTheme } from '../../context/ThemeContext'
import { API_LOGOUT_URL, APILogoutTypes } from '../../services/APIAuthorizationService'
import { APICall } from '../../services/APIService'
import { ThemeTypes } from '../../context/ContextTypes'
import { useUserData } from '../../context/UserDataContext'

export const accentColors: AccentColorTypes[] = [
		{name: 'blue', color: 'rgb(2, 117, 216)'},
		{name: 'green', color: 'rgb(92, 184, 92)'},
		{name: 'cyan', color: 'rgb(91, 192, 222)'},
		{name: 'yellow', color: 'rgb(240, 173, 78)'},
		{name: 'black', color: 'rgb(41, 43, 44)'},
		{name: 'brown', color: 'rgb(196, 64, 64)'},
		{name: 'orange', color: 'rgb(251,74,27)'}
]

export const themeModes: ThemeModesTypes[] = [
		{name: 'light', icon: <LightModeIcon color='var(--color-text)' width='1.3rem' className='icon'/>},
		{name: 'dark', icon: <DarkModeIcon color='var(--color-text)' width='1rem' className='icon'/>},
		{name: 'colorful', icon: <RainbowIcon color='var(--color-text)' width='1.3rem' className='icon'/>}
		
]

const ThemeSettings = (props: SettingsPropsTypes) => {

		const BASE_URL = process.env.REACT_APP_BASE_URL
		// Theme context
		const {theme, setTheme} = useTheme()

		const { username } = useUserData()
		// Selected accent color
		//const [currentAccent, setCurrentAccent] = useState<AccentTypes>('blue')

		/* const handleClick = (color: string, name: string) => {
				document.documentElement.style.setProperty('--color-accent', color)
				setCurrentAccent(name as AccentTypes)
		} */

		const [currentAccent, setCurrentAccent] = useState<AccentTypes>(() => {
				if (typeof window !== "undefined") {
				const userData = sessionStorage.getItem("userdetails");
				if (userData) {
						try {
						const parsedUser = JSON.parse(userData);
						const stored = parsedUser.themecolorbconex;
						const accentEntry = accentColors.find(
								(entry) => entry.name === stored
						);
						console.log(accentEntry);
						if (accentEntry) {
								document.documentElement.style.setProperty(
								"--color-accent",
								accentEntry.color
								);
						}
						return (stored as AccentTypes) || "blue";
						} catch (error) {
						console.error("Error parsing sessionStorage user:", error);
						}
				}
				}
				return "blue"; // fallback
	});

	useEffect(() => {
		const accentEntry = accentColors.find(
			(entry) => entry.name === currentAccent
		);
		if (accentEntry) {
			document.documentElement.style.setProperty(
				"--color-accent",
				accentEntry.color
			);
		}
	}, [currentAccent]);

	const handleClick = async (color: string, name: string) => {
		document.documentElement.style.setProperty("--color-accent", color);
		setCurrentAccent(name as AccentTypes);
	  
		const userData = sessionStorage.getItem("user");
		if (!userData) return;
	  
		try {
		  const parsedUser = JSON.parse(userData);
		  const username = parsedUser.preferred_username;
		  const token = localStorage.getItem("access_token");
	  
		  const response = await fetch(`${BASE_URL}/identity_manager/api/v1/updateuserthemecolor`, {
			method: "PUT",
			headers: {
			  Authorization: `Bearer ${token}`,
			  "Content-Type": "application/json",
			},
			body: JSON.stringify({
			  username: username,
			  themecolorbconex: name,
			}),
		  });
	  
		  const responseText = await response.text(); // always safe
	  
		  if (!response.ok) {
			console.error("Request failed:", response.status, responseText);
			throw new Error("Network response was not ok");
		  }
	  
		} catch (error) {
		  console.error("Error:", error);
		}
	  };

		const [isBorderOn, setIsBorderOff] = useState<boolean>(false)

		const handleBorderClick = () => {
			setIsBorderOff(prevState => !prevState)
		}

		// Logout button handle
		const logout = async () => {
				const accessToken: string | null = window.localStorage.getItem("accessToken")
				
				if(accessToken){
						const requestBody: APILogoutTypes = {
								accessToken: accessToken
						}

						const response = await APICall(API_LOGOUT_URL, 'POST', requestBody)

						if(response.httpStatus === 'OK')
						{
								window.location.href = '/login'
								window.localStorage.clear()
						}
				}
		}

		// Handle theme change button click
		/* const handleThemeChangeClick = (type: ThemeTypes) => {
				setTheme(prevState => type)
		} */

				// Handle theme change button click
	const handleThemeChangeClick = async (type: ThemeTypes) => {
		setTheme((prevState) => type);
		try {
			// const userData = sessionStorage.getItem("user");
			// if (!userData) {
			// 	console.error("No user data found in sessionStorage");
			// 	return;
			// }

			// let parsedUser;
			// try {
			// 	parsedUser = JSON.parse(userData);
			// } catch (parseError) {
			// 	console.error("Failed to parse user data:", parseError);
			// 	return;
			// }

			// const username = parsedUser.preferred_username;
			// if (!username) {
			// 	console.error("Username not found in user data");
			// 	return;
			// }

			const token = localStorage.getItem("access_token");
			if (!token) {
				console.error("No access token found");
				return;
			}

			const response = await fetch(`${BASE_URL}/identity_manager/api/v1/updateuserthememode`,
				{
					method: "PUT",
					headers: {
						Authorization: `Bearer ${token}`,
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						username: username,
						thememodebconex: type.toString(),
					}),
				}
			);

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			const responseData = await response.text();
			console.log("Theme save response", responseData);
		} catch (error) {
			console.error("Error in handleThemeChangeClick:", error);
		}
	};

		useEffect(() => {
				if(isBorderOn)
				{
						document.documentElement.style.setProperty('--border-status', 'solid')
				}
				else
				{
						document.documentElement.style.setProperty('--border-status', 'none')
				}
		}, [isBorderOn])

		// Set currant accent color selection
		useEffect(() => {
				const value: string = document.documentElement.style.getPropertyValue('--color-accent')

				for(let x = 0; x < accentColors.length; x++)
				{
						if(accentColors[x].color === value)
						{
								setCurrentAccent(accentColors[x].name)
								break
						}
				}
		}, [])
		return (
				<div className={`container-wrapper`}>
						<span className={`title`}>settings</span>

						<div className={`theme-setting-wrapper`}>
								<div className={`setting-container theme-wrapper`}>
										<div className={`title`}>
												<span>theme settings</span>
										</div>
										<div className={`left`}>
												<span className={`left-title`}>select theme mode</span>
												<div className={`theme-mode-wrapper`}>
														{themeModes.map((themes, index) => (
																<div key={index} className={`data-container`}>
																		<div onClick={() => handleThemeChangeClick(themes.name)} style={{borderStyle: theme === themes.name ? 'solid' : 'none'}}>
																				{themes.icon}
																		</div>
																		<span>{themes.name}</span>
																</div>
														))}
												</div>
										</div>
										<div className={`right`}>
												<span className={`right-title`}>select accent color</span>
												<div className={`accent-color-wrapper`}>
														{accentColors.map((color, index) => (
																<div key={index} className={`data-container`}>
																		<div className={`color-box`} style={{backgroundColor: color.color, borderStyle: color.name === currentAccent ? 'solid' : 'none'}} onClick={(e) => handleClick(color.color, color.name)}></div>
																		<span>{color.name}</span>
																</div>
														))}
												</div>
										</div>
								</div>
						</div>
				</div>
		)
}

export default ThemeSettings